import { render, staticRenderFns } from "./lecturePublish.vue?vue&type=template&id=2f49c7ec&"
import script from "./lecturePublish.vue?vue&type=script&lang=js&"
export * from "./lecturePublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports